import formButton from '@/components/common/form-button/form-button.vue'
import labelBig from '@/components/common/label-big/label-big.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    formButton,
    labelBig
  },
  props: {
    bodyClass: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: ''
    },
    closeButton: {
      type: Boolean
    }
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header
    },
    hasFooter() {
      return !!this.$slots.footer
    }
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    close: function () {
      this.setCurrentPopup(null)
    }
  },
  mounted() {
    document.addEventListener(
      'keydown',
      function closeModal(event) {
        if (event.keyCode === 27) {
          this.close()
          event.preventDefault()
          document.removeEventListener('keydown', closeModal)
        }
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/modal/modal.js